import { URL_PREFIX, BASE_API } from '@/const/const.js';
export default class Server {

    //判断ip所属国家
    static API_GET_IP_ADDRESS = URL_PREFIX + "/account/criteriaIpAddress";

    /*获取验证码*/
    // static DATABASE_API_USER_REQ_GET_VERIFY = URL_PREFIX + "/public/getCheckCode";

    //登录接口
    static API_POST_USER_LOGIN = URL_PREFIX + "/account/sign-up";

    //注册接口
    static DATABASE_API_USER_REG_URL = URL_PREFIX + "/account/reg";

    // 校验用户名接口
    static DATABASE_API_USER_CHECK_USERNAME = URL_PREFIX + '/account/reg/check_username';

    // 校验邮箱接口
    static DATABASE_API_USER_CHECK_EMAIL = URL_PREFIX + '/account/reg/check_email';

    // 校验手机号接口
    static DATABASE_API_USER_CHECK_PHONE = URL_PREFIX + '/account/reg/check_phone';

    // 发送邮箱获取验证码
    static DATABASE_API_USER_SEND_MESSAGE = URL_PREFIX + '/account/sendMessage';

    // 退出登录
    static API_GET_USER_LOGOUT = URL_PREFIX + '/account/sign-out';

    // 获取用户基本信息
    static API_GET_USER_INFO = URL_PREFIX + '/account/info';

    // 忘记密码
    static USER_DATABASE_API_GET_FORGOT_PASSWORD = URL_PREFIX + "/account/beforeLogin/password/update";

    // ========= SSO 模式：SAS 标准 OAuth2 端点 =========

    // SSO 授权码：302 到 SAS 标准端点（必须是 Gateway 绝对地址）
    static SSO_AUTHORIZE_URL = BASE_API + '/auth/oauth2/authorize';

    // SSO code 换 token → SAS 标准端点（form-urlencoded: grant_type=authorization_code&code=...&redirect_uri=...&client_id=...&code_verifier=...）
    static SSO_TOKEN_URL = BASE_API + '/auth/oauth2/token';

    // SSO currentUser → 补全 privileges / avatar / phonenumber（必须是 Gateway 绝对地址）
    static SSO_CURRENT_USER_URL = BASE_API + URL_PREFIX + '/account/currentUser';

    // SSO 登出 → GET 端点，清除 Auth Session 后 302 回 Celelens-app
    static SSO_LOGOUT_URL = BASE_API + '/auth/sso/logout';

}
